<div class="wrapper-lg">
    <app-breadcrumbs [items]="[{ url: '/final-paper-reviews', text: 'finalPaperReview_title' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'finalPaperReview_title' | translate}}</h1>
        <!-- Izslēgts līdz RSU sagatavo api/PersonData
        <aside *ngIf="canPickEmployee"> 
            <button type="button" class="btn btn-outline" (click)="togglePersonPicker()">
                <i class="fi fi-rs-badge"></i>
                {{'finalPaperReview_btnPickEmployee' | translate}} 
            </button>
        </aside> -->
    </header>

    <app-person-picker *ngIf="personPickerOpened" [personType]="personPickerType" (pick)="setPerson($event)"></app-person-picker>

    <ng-container *ngIf="!personPickerOpened">
        <div class="form-field required">
            <label class="form-label">{{'finalPaperReview_lblPlanningPeriod' | translate}}</label>
            <app-select [(ngModel)]="selectedPeriodId"
                        [options]="options.period"
                        [valueProperty]="'id'"
                        [displayProperty]="'name'"
                        [required]="true"
                        (selectionChange)="onPeriodChange()"
                        name="period">
                <ng-template #optionTemplate let-option>
                    <ng-container *ngIf="option.isChild">&mdash; </ng-container>{{option.name}}
                </ng-template>
            </app-select>
        </div>

        <ul ngbNav #nav="ngbNav" class="nav-tabs">
            <li ngbNavItem>
                <a ngbNavLink>{{'finalPaperReview_finalPapers' | translate}}</a>
                <ng-template ngbNavContent>
                    <div class="mt-3">
                        <app-final-paper-review-list [data]="finalPapers"></app-final-paper-review-list>
                    </div>
                </ng-template>
            </li>

            <li ngbNavItem *ngIf="showProtocols">
                <a ngbNavLink>{{'finalPaperReview_protocols' | translate}}</a>
                <ng-template ngbNavContent>
                    <div class="mt-3">
                        <app-final-paper-document-list [type]="'protocol'" [academicYearId]="selectedYear?.Id"></app-final-paper-document-list>
                    </div>
                </ng-template>
            </li>

            <li ngbNavItem *ngIf="showOrders">
                <a ngbNavLink>{{'finalPaperReview_orders' | translate}}</a>
                <ng-template ngbNavContent>
                    <div class="mt-3">
                        <app-final-paper-document-list [type]="'order'" [academicYearId]="selectedYear?.Id"></app-final-paper-document-list>
                    </div>
                </ng-template>
            </li>
        </ul>

        <div [ngbNavOutlet]="nav"></div>
    </ng-container>
</div>
